export const environment = {
  production: true,
  isOfficeAddin: false
};
